import React from 'react'
import PropertiesHeaderSection from '../PopularOwnerProperties/PropertiesSection'
import PropertyCard from '../../../Components/card/PropertyCard'
import ProjectCard from '../../../Components/card/projectCard';
import useFetch from '../../../hooks/useFetch';
import { fetchProjects } from '../../../services/projectService';
import {  getBhkTypesString, getImageUrl, getMinimumFloorPriceMin } from '../../../Utils/localStorageUtils';

const TopProjectsSection = () => {


  const { data: projects, loading, error } = useFetch(fetchProjects, []);



  console.log("projects",projects)


  return (
    <div>
    <PropertiesHeaderSection headerTitle="Top Projects" buttonText="See all Projects" navigateTo="/projects/list/all-projects" />
    {loading && <p className="text-center">Loading projects...</p>}
    {error && <p className="text-center text-red-500">Error: {error?.message}</p>}
    {!loading && !error && (
      <div className="px-8 flex overflow-x-auto space-x-4 py-2" style={{ scrollbarWidth: "none" }}>
        {projects?.map((project) => (
          <ProjectCard
            _id={project._id}
            key={project?._id}
            imageUrl={getImageUrl(project?.media?.projectPictures?.[0]) || "default-image.jpg"}
            title={project?.basicDetails?.projectName}
            projectBuilder={project?.basicDetails?.projectBuilder}
            price={`${getMinimumFloorPriceMin(project?.floorPricingDetails)}`}
            size={`${getBhkTypesString(project?.floorPricingDetails)}`}
            location={project?.basicDetails?.location?.formatted_address || "Jaipur"}
            status={project?.floorPricingDetails?.possessionYear ? `Possession: ${project?.floorPricingDetails?.possessionMonth} ${project?.floorPricingDetails?.possessionYear}` : "Upcoming"}
            photosCount={project?.media?.projectPictures?.length || 0}
          />
        ))}
      </div>
    )}
  </div>
  )
}

export default TopProjectsSection
